const getAzureProviderRelationshipRed = ( state = {
	isFetching: false,
	rootAccountAlias: '',
	bearerToken: ''
}, action )=>{
	switch ( action.type ) {
		case 'GET_AZURE_PROVIDER_RELATIONSHIP':
		return Object.assign({}, state, {
			isFetching: true,
			rootAccountAlias: action.payload.rootAccountAlias,
			bearerToken: action.payload.bearerToken
		});
		case 'RECEIVE_AZURE_PROVIDER_RELATIONSHIP':
		return Object.assign({}, state, {
			isFetching: false,
			json: action.json
		});
		default:
		return state;
	}
};

export default getAzureProviderRelationshipRed;


/** WEBPACK FOOTER **
 ** ./src/reducers/getAzureProviderRelationshipRed.js
 **/